import React from 'react';
import { PropTypes } from 'prop-types';
import Select from 'react-select';

class SelectInput extends React.Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    this.props.onChange(this.props.name, value);
  }

  render() {

    const { onChange, onBlur, value, id, name, ...rest } = this.props;

    return (
      <Select
        {...rest}
        id={name}
        onChange={this.handleChange}
        onBlur={onBlur}
        value={this.props.value} />
    );
  }
}

SelectInput.defaultProps = {
  labelKey: "name",
  valueKey: "id"
};

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  onChange: PropTypes.func
};

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/form/controls/SelectInput.js